import React from 'react'
import PropTypes from 'prop-types'
import InfoAndEditButton from './InfoAndEditButton'
import AddContactInfoButton from './AddContactInfoButton'

const ShowContact = ({ contactInfoLabel, contactInfo, editContact }) => (
  !!contactInfo ? (
    <InfoAndEditButton
      contactInfoLabel={contactInfoLabel}
      contactInfo={contactInfo}
      editContact={editContact}
    />
  ) : (
      <AddContactInfoButton
        contactInfoLabel={contactInfoLabel}
        editContact={editContact}
      />
    )
)

ShowContact.PropTypes = {
  contactInfoLabel: PropTypes.string.isRequired,
  contactInfo: PropTypes.string.isRequired,
  editContact: PropTypes.func.isRequired,
}

export default ShowContact



// WEBPACK FOOTER //
// ./src/components/PatientPage/PatientCard/ContactField/EnabledField/ShowContact/index.js